<template lang="pug">
.template-item-component
  .section-and-group(v-if="isSection(value) || isGroup(value)" :class="_margin")
    //- type: section
    .template-item.d-flex.flex-column(v-if="isSection(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text" v-html="formatTextWithLink(value.text)")
      .section-text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .mb-2
      .section-items
        .section-item(v-for="(property, index) in value.properties" :key="property.id")
          WaiterTemplateInputItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")

    //- type: group
    .template-group-item.d-flex.flex-column.mb-3(v-if="isGroup(value)")
      .d-flex.flex-row
        .section-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .section-text(v-if="value.text" v-html="formatTextWithLink(value.text)")
      .section-text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      .mb-2
      .group-items(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .group-item.pt-2.pb-2.mb-2
          .group-child-item(v-for="(childProperty, childIndex) in property" :key="value.id + '-' + index + '-' + childIndex")
            WaiterTemplateInputItem(v-model="value.properties[index][childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
          .d-flex.flex-row.justify-content-end.mr-3.mb-1
            button.btn.group-delete-btn(@click="onDeleteGroupItem(value, index)") 削除

      .buttons.d-flex.flex-row.justify-content-end
        button.btn.group-add-btn(@click="onAddGroupItem(value)"
          :class="{ 'disable': disableAddGroupItemButton(value) }" :disabled="disableAddGroupItemButton(value)") {{ value.displayAddButtonLabel }}

  .template-items(v-else :class="{ 'facility-only': value.displayToUser == false }").mr-3.mb-3.ml-3
    //- type: text
    .template-item.d-flex.flex-column(v-if="isText(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center(v-if="value.prefix || value.suffix")
        .text-prefix.mr-2(v-if="value.prefix") {{ value.prefix }}
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" :data-vv-as="value.label" :style="getTextStyle(value)")
        .text-suffix.ml-2 {{ value.suffix }}
      div(v-else)
        b-form-input(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :min="value.min" :max="value.max"
          :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" :data-vv-as="value.label" :style="getTextStyle(value)")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: radio
    .template-item.d-flex.flex-column(v-if="isRadio(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      template(v-if="value.align == 'vertical'")
        template(v-for="(option, index) in value.options")
          .radio-item(v-if="index == 0")
            b-form-radio(v-model="value.answer" :name="value.id" :value="option.value" v-validate="createValidateRules(value)" :data-vv-as="value.label") {{ option.text }}
          .radio-item(v-else)
            b-form-radio(v-model="value.answer" :name="value.id" :value="option.value") {{ option.text }}
        .radio-reset
          button.radio-reset-btn.btn(@click="value.answer = null") 選択解除
      template(v-else)
        b-form-radio-group.d-flex.flex-row.align-items-center.flex-wrap(:id="value.id" v-model="value.answer" :name="value.id" :options="value.options"
          v-validate="createValidateRules(value)" :data-vv-as="value.label")
          .radio-reset.custom-control-inline
            button.radio-reset-btn.btn(@click="value.answer = null") 選択解除
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: radioGroup
    .template-item-radio-group.d-flex.flex-column(v-if="isRadioGroup(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
      
      .radio-items.mb-2(v-if="value.properties" v-for="(property, index) in value.properties" :key="value.id + '-' + index")
        .radio-item(v-if="index == 0")
          b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value" v-validate="createValidateRules(value)" data-vv-as="本項目") {{ property.option.text }}
        .radio-item(v-else)
          b-form-radio(v-model="value.answer" :name="value.id" :value="property.option.value") {{ property.option.text }}
        .radio-properties.pt-2.mt-2(v-if="property.properties && 0 < property.properties.length && value.answer == property.option.value")
          .group-child-item(v-for="(childProperty, childIndex) in property.properties" :key="value.id + '-' + index + '-' + childIndex")
            WaiterTemplateInputItem(v-model="value.properties[index].properties[childIndex]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
      .radio-reset.mb-2
        button.radio-reset-btn.btn(@click="value.answer = null") 選択解除
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: select
    .template-item.d-flex.flex-column(v-if="isSelect(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      b-form-select.d-flex.flex-column(:id="value.id" v-model="value.answer" :name="value.id" :options="createSelectOptions(value.options)"
        :multiple="value.multiple" v-validate="createValidateRules(value)" :data-vv-as="value.label")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: checkbox
    .template-item.d-flex.flex-column(v-if="isCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false"
        v-validate="createValidateRules(value)" :data-vv-as="value.label") {{ value.question }}
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: siwtch checkbox
    .template-item-switch-checkbox.d-flex.flex-column(v-if="isSwitchCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      b-form-checkbox(:id="value.id" v-model="value.answer" :name="value.id" :value="true" :unchecked-value="false"
        v-validate="createValidateRules(value)" :data-vv-as="value.label") {{ value.question }}
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

      .checkbox-items.mt-2.mb-2(v-if="value.showRule == value.answer || (value.showRule == false && value.answer == null)")
        .checkbox-property.pt-2.mt-2(v-for="(property, index) in value.properties" :key="value.id + '-' + index")
          WaiterTemplateInputItem(v-model="value.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="true")
        
    //- type: multipleCheckbox
    .template-item-multiple-checkbox.d-flex.flex-column(v-if="isMultipleCheckbox(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .checkbox.mb-2(v-for="(question, index) in value.questions")
        b-form-checkbox(:id="value.id + '-' + index" v-model="value.answer[index]" :name="value.id + '-' + index"
          :value="true" :unchecked-value="false") {{ value.questions[index] }}
         
      input(type="hidden" :id="value.id" :name="value.id" v-model="value.answer" v-validate="createValidateRules(value)" :data-vv-as="value.label")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: textarea
    .template-item.d-flex.flex-column(v-if="isTextarea(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      b-form-textarea(:id="value.id" v-model="value.answer" :name="value.id" :placeholder="value.placeholder" :rows="value.rows"
        :no-resize="value.noResize" :minlength="value.minlength" :maxlength="value.maxlength" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
        v-validate="createValidateRules(value)" :data-vv-as="value.label")
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: address
    .template-item-address.d-flex.flex-column(v-if="isAddress(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row(v-if="value.answer")
        b-form-input.postal-code.mb-1.mr-2(:id="value.id + '-postal-code'" v-model="value.answer.postalCode" :name="value.id + '-postal-code'"
          placeholder="郵便番号" maxlength="8" :class="[ { noinput: (isRequired(value) && !value.answer.postalCode) } ]"
          v-validate="createValidateRules(value)" data-vv-as="郵便番号")
        button.btn.search-address-btn(type="button" @click="onSearchAddress(value)") 住所検索
      .error-messages(v-for="error in errors.collect(value.id + '-postal-code')")
        .error-message {{ error }}
      span.error-message(v-show="addressErrorMessage") {{ addressErrorMessage }}
      b-form-input(:id="value.id + '-address'" v-model="value.answer.address" :name="value.id + '-address'" placeholder="住所" maxlength="100"
        :class="[ { noinput: (isRequired(value) && !value.answer.address) } ]" v-validate="createValidateRules(value)" data-vv-as="住所")
      .error-messages(v-for="error in errors.collect(value.id + '-address')")
        .error-message {{ error }}

    //- type: birthday
    .template-item-birthday.d-flex.flex-column(v-if="isBirthday(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center(v-if="value.answer")
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
          :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
          :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
        span.ml-2.mr-2 月
        b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()"
          :class="[ { noinput: (isRequired(value) && !value.answer.date) } ]" v-validate="createValidateRules(value)" data-vv-as="日")
        span.ml-2.mr-2 日
        span(v-if="value.answer && value.answer.month &&value.answer.date ") （{{ createAge(value) }}歳）
      .error-messages(v-for="error in errors.collect(value.id + '-year')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-month')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-date')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: yearMonthDate
    .template-item-year-month-date(v-if="isYearMonthDate(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center(v-if="value.answer")
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
          :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
          :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
        span.ml-2.mr-2 月
        b-form-select.date(:id="value.id + '-date'" v-model="value.answer.date" :name="value.id + '-date'" :options="getDateOptions()"
          :class="[ { noinput: (isRequired(value) && !value.answer.date) } ]" v-validate="createValidateRules(value)" data-vv-as="日")
        span.ml-2.mr-2 日
        span.ml-2(v-if="value.suffix") {{ value.suffix }}
      .error-messages(v-for="error in errors.collect(value.id + '-year')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-month')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-date')")
        .error-message {{ error }}

    //- type: yearMonth
    .template-item-year-month-date(v-if="isYearMonth(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center(v-if="value.answer")
        b-form-select.year(:id="value.id + '-year'" v-model="value.answer.year" :name="value.id + '-year'" :options="getYearOptions(value)"
          :class="[ { noinput: (isRequired(value) && !value.answer.year) } ]" v-validate="createValidateRules(value)" data-vv-as="年")
        span.ml-2.mr-2 年
        b-form-select.month(:id="value.id + '-month'" v-model="value.answer.month" :name="value.id + '-month'" :options="getMonthOptions()"
          :class="[ { noinput: (isRequired(value) && !value.answer.month) } ]" v-validate="createValidateRules(value)" data-vv-as="月")
        span.ml-2.mr-2 月
        span.ml-2(v-if="value.suffix") {{ value.suffix }}
      .error-messages(v-for="error in errors.collect(value.id + '-year')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-month')")
        .error-message {{ error }}

    //- type: roomType
    .template-item-room-type(v-if="isRoomType(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .facility-recruitment(v-for="(checkbox, index) in value.answer")
        span.facility-name ・{{ getFacilityName(value.answer[index]) }}
        .checkboxs.ml-3
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'multiBed')" :id="value.id + '-' + checkbox.facilityId + '-multiBed'"
            v-model="value.answer[index].recruitmentRoom.multiBed" :value="true" :unchecked-value="false") 従来型多床室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'conventinalSingle')" :id="value.id + '-' + checkbox.facilityId + '-conventinalSingle'"
            v-model="value.answer[index].recruitmentRoom.conventinalSingle" :value="true" :unchecked-value="false") 従来型個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'unitTypeSingle')" :id="value.id + '-' + checkbox.facilityId + '-unitTypeSingle'"
            v-model="value.answer[index].recruitmentRoom.unitTypeSingle" :value="true" :unchecked-value="false") ユニット型個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'single')" :id="value.id + '-' + checkbox.facilityId + '-single'"
            v-model="value.answer[index].recruitmentRoom.single" :value="true" :unchecked-value="false") 個室
          b-form-checkbox(v-if="showRecruitmentRoom(value.answer[index], 'double')" :id="value.id + '-' + checkbox.facilityId + '-double'"
            v-model="value.answer[index].recruitmentRoom.double" :value="true" :unchecked-value="false") ２人部屋（夫婦部屋）
        .checkboxs.ml-3(v-if="value.answer[index].customRecruitmentRoom && 0 < value.answer[index].customRecruitmentRoom.length")
          b-form-checkbox(v-if="showCustomRecruitmentRoom(value.answer[index], room)"
            v-for="(room, roomIndex) in value.answer[index].customRecruitmentRoom"
            :id="value.id + '-' + checkbox.facilityId + '-' + room.id"
            v-model="value.answer[index].customRecruitmentRoom[roomIndex].use" :value="true" :unchecked-value="false") {{ room.name }}

      .error-messages(v-for="error in errors.collect(value.id)")
        .error-message {{ error }}

    //- type: file
    .template-item-file(v-if="isFile(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")
        span.error-message(v-show="fileErrorMesage") {{ fileErrorMesage }}

      template(v-for="(file, index) in value.tempAnswer")
        .d-flex.flex-row.align-items-center
          FileSelecter.mr-2(:id="value.id + '-' + index" v-model="value.tempAnswer[index]" :mimetype="createFileAccept(value)" :showDragAndDrop="false"
            :file-name="file && file.file ? file.file.name : ''" height="28px" :disableDeleteButton="disableFileDeleteButton(value)" 
            @on-delete="onDeleteFile(value, index)")
          input(v-if="file" v-model="value.tempAnswer[index].file" :name="value.id + '-' + index"
            v-validate="createValidateRules(value)" :data-vv-as="value.label" type="hidden")
          button.btn.file-preview-btn(@click="onFilePreview(value, index)"
            :class="{ 'disable': disableFilePreviewButton(value, index) }" :disabled="disableFilePreviewButton(value, index)") プレビュー
        .error-messages(v-for="error in errors.collect(value.id + '-' + index)")
          .error-message {{ error }}
        .mb-2
      button.btn.add-file-btn(type="button" @click="onAddFile(value)" :class="{ 'disable': disableAddFileButton(value) }"
        :disabled="disableAddFileButton(value)") ファイルを追加

      PdfModal(v-model="showPdfModal" :pdfUrl="pdfModalUrl")
      ImageModal(v-model="showImageModal" :imageUrl="imageModalUrl")

    //- type: tel
    .template-item-tel.d-flex.flex-column(v-if="isTel(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center(v-if="value.answer")
        b-form-input.tel-input(:id="value.id + '-first'" v-model="value.answer.first" :name="value.id + '-first'" 
          :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="電話番号１")
        span.ml-2.mr-2 －
        b-form-input.tel-input(:id="value.id + '-second'" v-model="value.answer.second" :name="value.id + '-second'" 
          :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="電話番号２")
        span.ml-2.mr-2 －
        b-form-input.tel-input(:id="value.id + '-third'" v-model="value.answer.third" :name="value.id + '-third'" 
          :minlength="3" :maxlength="4" :class="[ { noinput: (isRequired(value) && !value.answer) } ]"
          v-validate="createValidateRules(value)" data-vv-as="電話番号３")

      .error-messages(v-for="error in errors.collect(value.id + '-first')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-second')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-third')")
        .error-message {{ error }}

    //- type: name
    .template-item-name.d-flex.flex-column(v-if="isName(value)")
      .item-labels.d-flex.flex-row.align-items-center
        .item-label.mr-1(v-if="value.label && value.showLabel") {{ value.label }}
        span.validation-label.mr-1(v-if="isRequired(value)") 必須
        span.facility-only-label.mr-1(v-if="value.displayToUser == false") 施設ユーザーのみ入力可能
        HelpIcon(v-if="value.helpText" :popoverId="'help-icon-' + value.id" :text="value.helpText")
      .item-texts.d-flex.flex-column
        .text(v-if="value.text" v-html="formatTextWithLink(value.text)")
        .text.warning-message(v-if="value.strongText" v-html="formatTextWithLink(value.strongText)")

      .d-flex.flex-row.align-items-center.mb-1(v-if="value.answer")
        span.template-item-name-sub-label.mr-2 姓
        b-form-input.name-input.mr-4(:id="value.id + '-second'" v-model="value.answer.secondName" :name="value.id + '-second'" :placeholder="'姓'"
          :maxlength="15" :class="[ { noinput: !value.answer.secondName } ]" v-validate="createValidateRules(value)" data-vv-as="姓")
        span.template-item-name-sub-label.mr-2 名
        b-form-input.name-input(:id="value.id + '-first'" v-model="value.answer.firstName" :name="value.id + '-first'" :placeholder="'名'"
          :maxlength="15" :class="[ { noinput: !value.answer.firstName } ]" v-validate="createValidateRules(value)" data-vv-as="名")
      .d-flex.flex-row.align-items-center(v-if="value.answer")
        span.template-item-name-sub-label.mr-2 せい
        b-form-input.name-input.mr-4(:id="value.id + '-second-kana'" v-model="value.answer.secondKanaName" :name="value.id + '-second-kana'" :placeholder="'せい'"
          :maxlength="15" :class="[ { noinput: !value.answer.secondKanaName } ]" v-validate="createValidateRules(value, { 'hiraganaAndNumbers': true })" data-vv-as="せい")
        span.template-item-name-sub-label.mr-2 めい
        b-form-input.name-input(:id="value.id + '-first-kana'" v-model="value.answer.firstKanaName" :name="value.id + '-first-kana'" :placeholder="'めい'"
          :maxlength="15" :class="[ { noinput: !value.answer.firstKanaName } ]" v-validate="createValidateRules(value, { 'hiraganaAndNumbers': true })" data-vv-as="めい")
      .error-messages(v-for="error in errors.collect(value.id + '-second')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-first')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-second-kana')")
        .error-message {{ error }}
      .error-messages(v-for="error in errors.collect(value.id + '-first-kana')")
        .error-message {{ error }}
        
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import Setting from "../../../../public/setting.json";

import {
  TemplateItem,
  TemplateType,
  TemplateItemAddress,
  TemplateItemBirthday,
  TemplateItemYearMonthDate,
  TemplateItemFile,
  TemplateItemInput,
  TemplateItemGroup,
  TemplateItemText,
  RoomType,
  SelectOption
} from "@/commons/services/AdmissionApplicationTemplates";
import { CustomRecruitmentRoom, FacilityGetModel, RecruitmentRoom } from "@/commons/services/Facilities";
import ZipcloudService, { ZipcloudGetModel } from "@/commons/services/Zipcloud";
import S3UrlService from "@/commons/services/S3Url";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import ImageModal from "@/pc/basics/ImageModal.vue";
import ChildTemplateItem from "@/pc/containers/waiters/WaiterTemplateInputItem.vue";
import FileSelecter from "@/pc/basics/FileSelecter.vue";

/**
 * ### 待機者登録画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    HelpIcon,
    PdfModal,
    ImageModal,
    ChildTemplateItem,
    FileSelecter
  },
  // 再帰呼び出しする場合、proビルド時にコンポーネント名が書き換えられて動かなくなるので明示的に定義する
  name: "WaiterTemplateInputItem"
})
export default class WaiterTemplateInputItem extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  /** zipcloudサービス */
  @Inject("ZipcloudService") zipcloudService!: ZipcloudService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** テンプレート情報 */
  @Prop({ required: true })
  value!: TemplateItem;

  /** 閲覧可能施設 */
  @Prop({ required: true })
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  /** 子要素かどうか */
  @Prop({ required: true })
  isChaild!: boolean;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** type:address のエラーメッセージ */
  addressErrorMessage: string = "";

  /** type:file のPDFプレビューモーダル表示可否 */
  showPdfModal: boolean = false;
  /** type:file のPDFプレビューモーダルで表示する対象のURL */
  pdfModalUrl: string = "";
  /** type:file の画像プレビューモーダル表示可否 */
  showImageModal: boolean = false;
  /** type:file の画像プレビューモーダルで表示する対象のURL */
  imageModalUrl: string = "";
  /** type:file のエラーメッセージ */
  fileErrorMesage: string = "";

  get _margin(): string[] {
    if (this.isChaild == true) {
      return ["mr-3", "mb-3", "ml-3"];
    } else {
      return [""];
    }
  }

  /**
   * テキスト内の Markdown リンク記法 `link` を `<a>` タグに変換します。
   * クロスサイトスクリプティング（XSS）対策として、タグ変換前に HTML エスケープを行います。
   */
  public formatTextWithLink(text: string | undefined): string {
    if (!text) {
      return "";
    }

    // HTMLエスケープ処理
    let escapedText = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");

    // Markdown リンク テキスト を <a> タグに変換
    const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    return escapedText.replace(linkRegex, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  }

  public isSection(item: TemplateItem): boolean {
    if (item.type != TemplateType.SECTION) {
      return false;
    }
    return true;
  }

  public isGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.GROUP) {
      return false;
    }
    return true;
  }

  public onDeleteGroupItem(item: TemplateItemGroup, index: number): void {
    item.properties.splice(index, 1);

    // idの採番し直し
    for (let i = 0; i < item.properties.length; i++) {
      for (let j = 0; j < item.properties[i].length; j++) {
        const id: string = item.template[i].id;
        item.properties[i][j].id = `${id}${i}`;
      }
    }

    return;
  }

  public disableAddGroupItemButton(item: TemplateItemGroup): boolean {
    if (item.displayAddButton && !item.max) {
      console.error("template format error. type:group displayAddButton=true but max=undefined");
      return true;
    }
    if (item.max && item.properties.length < item.max) {
      return false;
    }

    return true;
  }

  public onAddGroupItem(item: TemplateItemGroup): void {
    let templateClone: Array<TemplateItem> = JSON.parse(JSON.stringify(item.template));

    const suffix: number = item.properties.length;
    for (const cloneItem of templateClone) {
      cloneItem.id = `${cloneItem.id}${suffix}`;
    }
    item.properties.push(templateClone);

    return;
  }

  public isText(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXT) {
      return false;
    }
    return true;
  }

  public getTextStyle(item: TemplateItemText): string {
    if (!item.width) {
      return "";
    }
    return `width:${item.width}px;`;
  }

  public createValidateRules(item: TemplateItem, addValidationNames?: { [key: string]: number | boolean }): any {
    let rules: any = {};

    // itemの保持するルールをオブジェクト化する
    const inputItem: TemplateItemInput = item as TemplateItemInput;

    if (inputItem.validationRules == null) {
      return rules;
    }

    for (const rule of inputItem.validationRules) {
      const splitedRule: string[] = rule.split(":");
      if (splitedRule.length == 1) {
        rules[`${splitedRule[0]}`] = true;
      } else {
        rules[`${splitedRule[0]}`] = splitedRule[1];
      }
    }

    // 追加用のバリデーションルールがあれば追加する
    if (addValidationNames) {
      for (const key in addValidationNames) {
        if (Object.prototype.hasOwnProperty.call(addValidationNames, key)) {
          // addValidationNames のプロパティを rules にコピー
          // 既存のルールでも上書きする
          rules[key] = addValidationNames[key];
        }
      }
    }

    // ファイル種別毎のルールを追加する
    switch (item.type) {
      case TemplateType.TEXT:
      case TemplateType.RADIO:
      case TemplateType.RADIO_GROUP:
      case TemplateType.SELECT:
      case TemplateType.CHECKBOX:
      case TemplateType.TEXTAREA:
      case TemplateType.ADDRESS:
      case TemplateType.BIRTHDAY:
      case TemplateType.YEAR_MONTH:
      case TemplateType.YEAR_MONTH_DATE:
      case TemplateType.ROOM_TYPE: {
        break;
      }
      case TemplateType.FILE: {
        // TODO #3645の対応でvalidationが動かなくなってしまったのでコメントアウト
        // 自前でバリデーションするしかない
        // rules["file_size"] = 10;
        break;
      }
      case TemplateType.TEL: {
        rules["max"] = 4;
        rules["custom_numeric"] = true;
        break;
      }
      case TemplateType.NAME: {
        rules["max"] = 15;
        break;
      }
      case TemplateType.MULTIPLE_CHECKBOX: {
        // requiredが格納されている場合、配列内に1つ以上のtrueを指すので「atLeastOneTrue」に置き換える
        if (rules["required"] == true) {
          rules["atLeastOneTrue"] = true;
          delete rules["required"];
        }
        break;
      }
      default: {
        return {};
      }
    }
    return rules;
  }

  public isRadio(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO) {
      return false;
    }
    return true;
  }

  public isRadioGroup(item: TemplateItem): boolean {
    if (item.type != TemplateType.RADIO_GROUP) {
      return false;
    }
    return true;
  }

  public isSelect(item: TemplateItem): boolean {
    if (item.type != TemplateType.SELECT) {
      return false;
    }
    return true;
  }

  public createSelectOptions(sourceOptions: Array<SelectOption>): Array<SelectOption> {
    const options: Array<SelectOption> = [];

    let existNullOption: boolean = false;
    for (const sourceOption of sourceOptions) {
      if (sourceOption.value == null) {
        existNullOption = true;
      }
    }
    if (existNullOption == false) {
      options.push({ text: "", value: null as any });
    }
    return options.concat(sourceOptions);
  }

  public isCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.CHECKBOX) {
      return false;
    }
    return true;
  }

  public isSwitchCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.SWITCH_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isMultipleCheckbox(item: TemplateItem): boolean {
    if (item.type != TemplateType.MULTIPLE_CHECKBOX) {
      return false;
    }
    return true;
  }

  public isTextarea(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEXTAREA) {
      return false;
    }
    return true;
  }

  public isAddress(item: TemplateItem): boolean {
    if (item.type != TemplateType.ADDRESS) {
      return false;
    }
    return true;
  }

  public async onSearchAddress(item: TemplateItemAddress): Promise<void> {
    if (!item.answer.postalCode) {
      return;
    }

    const address: ZipcloudGetModel = await this.zipcloudService.get(item.answer.postalCode);
    if (!address.results) {
      this.addressErrorMessage = "郵便番号から住所が取得できませんでした。手動で入力してください。";
      return;
    } else {
      this.addressErrorMessage = "";
      item.answer.address = `${address.results[0].address1}${address.results[0].address2}${address.results[0].address3}`;
    }

    return;
  }

  public isBirthday(item: TemplateItem): boolean {
    if (item.type != TemplateType.BIRTHDAY) {
      return false;
    }
    return true;
  }

  public getYearOptions(item: TemplateItemBirthday | TemplateItemYearMonthDate): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    const currentYear: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyy");
    const startPosition: number = currentYear - item.startYearRange;
    const count: number = item.startYearRange + item.endYearRange;

    for (let i = 0; i <= count; i++) {
      const year: number = startPosition + i;
      const date = new Date(year, 11, 31, 0, 0);
      const intlOptions: Intl.DateTimeFormatOptions = { year: "numeric" };
      const jpYear: string = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", intlOptions).format(date).slice(0, -1); // 年が重複するので最終文字だけ削除;

      options.push({
        text: `${year}（${jpYear}）`,
        value: `${year}`
      });
    }

    return options;
  }

  public getMonthOptions(): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    for (let i = 1; i <= 12; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public getDateOptions(): Array<{ text: string; value: string | null }> {
    const options: Array<{ text: string; value: string | null }> = [{ text: "", value: null }]; // 初期値にリセット用の選択肢を用意しておく

    for (let i = 1; i <= 31; i++) {
      options.push({
        text: `${i}`,
        value: `${i}`
      });
    }

    return options;
  }

  public createAge(item: TemplateItemBirthday): number {
    const age: number = this.$dateUtil.convertBirthdayToAge(Number(item.answer.year), Number(item.answer.month), Number(item.answer.date));
    return age;
  }

  public isYearMonthDate(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH_DATE) {
      return false;
    }
    return true;
  }

  public isYearMonth(item: TemplateItem): boolean {
    if (item.type != TemplateType.YEAR_MONTH) {
      return false;
    }
    return true;
  }

  public isRoomType(item: TemplateItem): boolean {
    if (item.type != TemplateType.ROOM_TYPE) {
      return false;
    }
    return true;
  }

  public showRecruitmentRoom(roomType: RoomType, roomTypeName: string): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return false;
    }
    const recruitmentRoom: RecruitmentRoom = facility.recruitmentRoom;

    return recruitmentRoom[roomTypeName];
  }

  public showCustomRecruitmentRoom(roomType: RoomType, room: CustomRecruitmentRoom): boolean {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    // 施設にカスタム部屋種類が存在しない場合は表示不要
    if (!facility || !facility.customRecruitmentRoom || facility.customRecruitmentRoom.length <= 0) {
      return false;
    }

    // 施設のカスタム部屋種類の使用可否を表示可否として返す
    for (const customRoom of facility.customRecruitmentRoom) {
      if (customRoom.id == room.id) {
        return customRoom.use;
      }
    }

    return false;
  }

  public getFacilityName(roomType: RoomType): string {
    const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

    if (!facility) {
      return "";
    }

    return facility.name;
  }

  public isFile(item: TemplateItem): boolean {
    if (item.type != TemplateType.FILE) {
      return false;
    }
    return true;
  }

  public createFileAccept(item: TemplateItemFile): string {
    if (!item.accept) {
      return "";
    }
    return item.accept.join(", ");
  }

  public isTel(item: TemplateItem): boolean {
    if (item.type != TemplateType.TEL) {
      return false;
    }
    return true;
  }

  public isName(item: TemplateItem): boolean {
    if (item.type != TemplateType.NAME) {
      return false;
    }
    return true;
  }

  public isRequired(item: TemplateItemInput): boolean {
    if (item.validationRules == null) {
      return false;
    }

    for (const validationRule of item.validationRules) {
      if (validationRule == "required") {
        return true;
      }
    }
    return false;
  }

  public onDeleteFile(item: TemplateItemFile, index: number): void {
    if (item.tempAnswer == null) {
      item.tempAnswer = [];
    }
    if (item.answer == null) {
      item.answer = [];
    }

    if (item.tempAnswer.length <= 1) {
      item.tempAnswer[index] = {
        file: null as any,
        fileName: ""
      };
      if (item.answer == null) {
        item.answer = [];
      }
      item.answer[index] = {
        name: "",
        url: ""
      };
    } else {
      item.tempAnswer.splice(index, 1);
      if (item.answer == null) {
        item.answer = [];
      }
      item.answer.splice(index, 1);
    }
    this.$forceUpdate(); // 再描画しないとFileSelecterコンポーネントが再描画されない
    return;
  }

  public async onFilePreview(item: TemplateItemFile, index: number): Promise<void> {
    if (item.tempAnswer == null || !item.answer) {
      return;
    }
    if (!item.tempAnswer[index]) {
      this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
      return;
    }

    // tempAnswerにデータがあるが、正しいデータ形式ではない（fileNameまたはfileが無い）場合はtempAnswerを作り直す
    if (item.tempAnswer) {
      let isError = false;
      if (!item.tempAnswer[index].file || !item.tempAnswer[index].fileName || item.tempAnswer[index].file instanceof File == false) {
        isError = true;
      }
      // ここでtempAnswerをnullにすると画面上で一度ファイルが消えたように見えるので、ここでtempAnswerを作り直す
      if (isError && item.answer[index]) {
        this.isBusy = true;
        this.loadingMessage = "読込み中...";

        // S3からファイルを取得しなおす
        const s3File: File = await this.getS3File(item.answer[index].url, item.answer[index].name);
        item.tempAnswer[index] = {
          file: s3File,
          fileName: s3File.name
        };

        this.isBusy = false;
      }
    }

    switch (item.tempAnswer![index].file.type) {
      case "image/jpeg":
      case "image/png": {
        const url: string = await FileReaderWrapper.readAsDataURL(item.tempAnswer![index].file);
        this.imageModalUrl = url;
        this.showImageModal = true;
        break;
      }
      case "application/pdf": {
        const url: string = window.URL.createObjectURL(item.tempAnswer![index].file);
        this.pdfModalUrl = url;
        this.showPdfModal = true;
        break;
      }
      default: {
        this.fileErrorMesage = "プレビュー非対応のファイル種別のため表示できません。";
        break;
      }
    }

    return;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  private async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  public disableFileDeleteButton(item: TemplateItemFile): boolean {
    if (item.tempAnswer == null) {
      return true;
    }

    if (item.tempAnswer.length <= 1 && item.tempAnswer[0].file == null) {
      return true;
    } else {
      return false;
    }
  }

  public disableFilePreviewButton(item: TemplateItemFile, index: number): boolean {
    if (item.tempAnswer == null) {
      return true;
    }

    if (item.tempAnswer[index] && item.tempAnswer[index].file) {
      return false;
    }
    return true;
  }

  public onAddFile(item: TemplateItemFile): void {
    if (item.tempAnswer == null) {
      return;
    }

    if (item.tempAnswer.length <= item.maxlength) {
      item.tempAnswer.push({
        file: null as any,
        fileName: ""
      });
    }
    this.$forceUpdate(); // 再描画しないとFileSelecterコンポーネントが再描画されない
    return;
  }

  public disableAddFileButton(item: TemplateItemFile): boolean {
    if (item.tempAnswer == null) {
      return false;
    }

    if (item.maxlength <= item.tempAnswer.length) {
      return true;
    } else {
      let existNullFile: boolean = false;
      for (const file of item.tempAnswer) {
        if (file.file == null) {
          existNullFile = true;
          break;
        } else if (!file.fileName) {
          existNullFile = true;
          break;
        }
      }
      if (existNullFile) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.template-item-component {
  .section-label,
  .item-label {
    font-weight: bold;
  }

  .section-text,
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .template-group-item {
    .group-item {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }

    .group-delete-btn,
    .group-add-btn {
      font-size: 16px !important;
      height: 38px !important;
    }
  }

  .facility-only {
    background-color: rgba(245, 245, 245, 1);
    padding: 8px;
  }
  .facility-only-label {
    color: rgba(138, 138, 138, 1);
    font-size: 10px;
    border: 1px solid rgba(138, 138, 138, 1);
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }

  .radio-reset-btn {
    height: 24px !important;
    font-size: 12px !important;
    padding: 3.5px 10px !important;
  }

  .template-item-radio-group {
    .radio-properties {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .template-item-switch-checkbox {
    .checkbox-items {
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
    }
  }

  .template-item-address {
    .postal-code {
      width: 160px;
    }
    .search-address-btn {
      font-size: 16px !important;
      width: 100px !important;
      height: 38px !important;
    }
  }

  .template-item-birthday,
  .template-item-year-month-date {
    .year {
      width: 180px;
    }
    .month {
      width: 70px;
    }
    .date {
      width: 70px;
    }
  }

  .template-item-room-type {
    .facility-name {
      font-weight: bold;
    }
  }

  .template-item-file {
    // ファイル選択のボタンを他のボタンと同じデザインに変更する
    .template-file {
      ::after {
        background-color: $btn !important;
        color: $btn-font !important;
        height: 38px !important;

        &:hover,
        &:focus {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &.disable {
          background-color: $btn-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        &:active {
          background-color: $btn-hover !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .setlectedと組み合わせた場合のボタン色を指定する
        &.selected {
          background-color: $btn-selected !important;
          color: $btn-font-selected !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
        // .disableと組み合わせた場合のボタン色を指定する
        &.disable {
          cursor: not-allowed;
          background-color: $btn-disable !important;
          color: $btn-font-disable !important;
          transition: background-color 0.25s ease-out, box-shadow 0.25s ease-out, color 0.25s ease-out;
        }
      }
    }
    .file-preview-btn {
      font-size: 14px !important;
      width: 130px;
      height: 32px !important;
    }
    .add-file-btn {
      font-size: 14px !important;
      min-width: 124px;
      margin: 0;
      height: 32px !important;
      padding: 4px 4px !important;
    }
  }

  .template-item-tel {
    .tel-input {
      width: 80px;
    }
  }

  .template-item-name {
    .template-item-name-sub-label {
      width: 2rem;
    }
    .name-input {
      width: 300px;
    }
  }
}
</style>
